<template>
  <div>
    <div class="option-config-util" v-show="configState">
      新增 <span :name="`py-option-config-${item}`" style="margin:0 5px;cursor:pointer" v-for="(item) in types" :key="item" @click="itemClick(item)">
        ({{typeName[item]}})
      </span>
    </div>
    <el-dialog 
      :width="`${dialogWidth[item]}`"
      @close="dialogClose(item)" 
      :title="`创建${typeName[item]}`" 
      v-for="(item,index) in zIndex" 
      :key="index" 
      append-to-body
      :visible="zIndex[index] ? true : false"
      top="10vh">
      <bind-position-component :form="formMap[item]" v-if="item === 10 || item === 20" @configSuccess="callback" @closeBox="closeAddBox" :bindType="item"></bind-position-component>
      <position-setting-form :formData="formMap[30]" v-if="item === 30" @refreshTreeList="callback"></position-setting-form>
      <supplier-form :form="formMap[40]" v-if="item === 40" @configSuccess="callback" @closeBox="closeAddBox"></supplier-form>
      <reim-type-form  :form="formMap[50]" v-if="item === 50" @configSuccess="callback" @closeBox="closeAddBox"></reim-type-form>
      <collection-type-form  :form="formMap[60]" v-if="item === 60" @configSuccess="callback" @closeBox="closeAddBox"></collection-type-form>
    </el-dialog>
  </div>
</template>
<script>
import {mapMutations} from 'vuex'
import {InitBindPosition,InitCreatePosition,SupplierCreater,ReimConfigCreator,CollectionTypeCreator} from '@/util/formCreater'
import bindPositionComponent from '@/components/Setting/BindPositionComponent'
import positionSettingForm from '@/components/Setting/PositionSettingForm'
import SupplierForm from '@/components/Finance/SupplierForm'
import ReimTypeForm from '@/components/Finance/ReimTypeForm'
import CollectionTypeForm from '@/components/Finance/CollectionTypeForm'
export default  {
  data() {
    return {
      dialogWidth: {
        10: '810px',
        20: '810px',
        30: '910px',
        40: '810px',
        50: '510px',
        60: '510px'
      },
      formMap: {
        10: {},
        20: {},
        30: {},
        40: {},
        50: {},
        60: {}
      },
      createForm: {
        10: () => this.formMap[10] = new InitBindPosition(),
        20: () => this.formMap[20] = new InitBindPosition(),
        30: () => this.formMap[30] = new InitCreatePosition(),
        40: () => this.formMap[40] = new SupplierCreater(),
        50: () => this.formMap[50] = new ReimConfigCreator(),
        60: () => this.formMap[60] = new CollectionTypeCreator(),
      },
      typeName: {
        10: '部门经理',
        20: '主管组长',
        30: '职位',
        40: '供应商',
        50: '支出类型',
        60: '收款类型'
      },
      zIndex: [],
      fns: [],
      state: false,
      previewBoxStatus:false,
      previewVoucher:null
    }
  },
  computed: {
    configState() {
      return this.$store.state.PopperConfig.configState
    },
    types() {
      const config = this.$store.state.PopperConfig
      return config.types
    },
    fnMap() {
      return this.$store.state.PopperConfig.fnMap
    },
    valueMap() {
      // console.log(this.$store.state.PopperConfig.valueMap)
      return this.$store.state.PopperConfig.valueMap
    }
  },
  methods: {
    ...mapMutations(['refreshConfigState']),
    closeAddBox(){
      this.spliceControl()
    },
    callback(res,close = true,create = false) {
      this.fns[this.fns.length - 1](res,this.zIndex[this.zIndex.length - 1])
      if(close) {
        this.refreshConfigState()
        this.spliceControl()
      }
      if(create) {
        const currType = this.zIndex[this.zIndex.length - 1]
        this.formMap[currType] = this.createForm[currType]()
      }
      
    },
    itemClick(type) {
      // console.log(type)
      this.formMap[type] = this.createForm[type]()
      this.zIndex.push(type)
      this.fns.push(this.fnMap[type])
      // console.log(this.zIndex,this.fns,this.valueMap)
    },
    spliceControl() {
      this.fns.splice(this.fns.length - 1, 1)
      this.zIndex.splice(this.zIndex.length - 1 , 1)
    },
    dialogClose(type) {
      this.spliceControl()
    }
  },
  components: {
    bindPositionComponent,
    positionSettingForm,
    SupplierForm,
    ReimTypeForm,
    CollectionTypeForm
  }
}
</script>
<style lang="scss" scoped>
.item {
  height: 25px;
  line-height: 25px;
  border-bottom: 1px solid #fff;
  cursor: pointer;
}
.option-config-util {
  background:#f13736;
  text-align:center;
  font-size:12px;
  color:#fff;
  padding: 5px 0;
  
}
</style>





// WEBPACK FOOTER //
// src/components/Util/OptionConfigUtil.vue